import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import ClearLayout from '@/layouts/ClearLayout.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';

import LoginPage from '@/pages/Auth/LoginPage.vue';
import HomePage from '@/pages/HomePage.vue';
import { STORAGE } from '@/constants/storage.constants';

import ADMINS_ROUTES from './admins.routes';
import NETWORK_ROUTES from './network.routes';
import UNITS_ROUTES from './units.routes';
import CAMPAIGN_ROUTES from './campaign.routes';
import CLIENTS_ROUTES from './clients.routes';
import PRODUCTS_ROUTES from './products.routes';
import CAMPAIGN_POINTS_TABLE from './campaign-points.routes';
import SALES_ROUTES from './sales.routes';
import BANNERS_ROUTES from './banners.routes';
import FEATURED_BANNERS_ROUTES from './featured-banners.routes';
import INFORMATIVES_ROUTES from './informatives.routes';
import TRAININGS_ROUTES from './trainings.routes';
import TRAINING_REPORTS_ROUTES from './training-reports.routes';
import EXCHANGE_ROUTES from './exchanges.routes';
import HIGHLIGHTS_ROUTES from './store-hightlights.routes';
import REDEMPTIONS_ROUTES from './redemptions.routes';
import CARD_SHIPPING_FEES_ROUTES from './card-shipping-fees.routes';
import API_USERS_ROUTES from './api-users.routes';
import FORM_RECIPIENTS_ROUTES from './form-recipients.routes';
import TERMS_OF_ACCEPTANCE_ROUTES from './terms-of-acceptance.routes';
import IMPORTS_ROUTES from './imports.routes';
import REPORTS_ROUTES from './reports.routes';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticated = (to, from, next) => {
  localStorage.setItem(STORAGE.PAGE_URL, to.path);

  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

const routes = [
  {
    path: '/login',
    component: ClearLayout,
    beforeEnter: ifNotAuthenticated,
    children: [
      {
        path: '',
        name: 'login',
        component: LoginPage,
      },
    ],
  },
  {
    path: '*',
    name: 'error',
    component: () => import('@/pages/ErrorPage.vue'),
  },
  {
    path: '/',
    beforeEnter: ifAuthenticated,
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'admin.index',
        component: HomePage,
      },
      {
        path: 'platform-regulations',
        name: 'platform-regulations.index',
        component: () =>
          import('@/pages/PlatformRegulations/PlatformRegulationsPage.vue'),
      },
      ADMINS_ROUTES,
      NETWORK_ROUTES,
      CAMPAIGN_ROUTES,
      UNITS_ROUTES,
      CLIENTS_ROUTES,
      PRODUCTS_ROUTES,
      CAMPAIGN_POINTS_TABLE,
      SALES_ROUTES,
      BANNERS_ROUTES,
      FEATURED_BANNERS_ROUTES,
      INFORMATIVES_ROUTES,
      TRAININGS_ROUTES,
      TRAINING_REPORTS_ROUTES,
      EXCHANGE_ROUTES,
      HIGHLIGHTS_ROUTES,
      REDEMPTIONS_ROUTES,
      CARD_SHIPPING_FEES_ROUTES,
      API_USERS_ROUTES,
      FORM_RECIPIENTS_ROUTES,
      TERMS_OF_ACCEPTANCE_ROUTES,
      IMPORTS_ROUTES,
      REPORTS_ROUTES,
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
